import {useContext} from 'react'
import {SitePreferenceContext} from '../components/contexts'

export const useSiteCustomPreferences = () => {
    const prefContext = useContext(SitePreferenceContext)
    if (prefContext === undefined) {
        throw new Error('useSiteCustomPreferences must be used within SitePreferenceProvider')
    }

    return prefContext
}
